import React from "react";
import Preloader from "../helper/Preloader";
import Breadcrumb from "../components/Breadcrumb";
 import BottomFooter from "../components/BottomFooter";
  import ScrollToTop from "react-scroll-to-top";
 import FooterOne from "../components/FooterOne";
 import OrderViewAmazonVendor from "../componentsAmazon/OrderViewAmazonVendor";
import HeaderFooterInit from "../componentsAmazon/HeaderFooterInit";
   

const PendingOrderVendor = () => {



  return (
    <>

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

     {/* HeaderFooterInit */}
     <HeaderFooterInit/>
      {/* Penging */}
      <OrderViewAmazonVendor />
 

      {/* FooterTwo */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />


    </>
  );
};

export default PendingOrderVendor;
